import { useEffect } from 'react';

import { NavigableItem } from 'services/schemableFormNavigation/schemableFormNavigation';

import {
  NavigableAnnotationPopoverProps,
  SchemableFormNavigationContext,
  SchemableFormNavigationContextType,
} from './SchemableFormNavigationContext';
import { useNavigableItemPopover } from './useNavigableItemPopover';

export const SchemableFormNavigationContextProvider = <T extends NavigableItem>({
  containerRef,
  children,
  NavigableItemPopoverComponent,
  service,
}: Omit<SchemableFormNavigationContextType<T>, 'useNavigableItemPopover'> & {
  children: React.ReactNode;
}) => {
  useEffect(() => {
    if (!containerRef) {
      return;
    }

    service.containerRef = containerRef;
    return () => {
      service.containerRef = null;
    };
  }, [service, containerRef]);

  const contextValue: SchemableFormNavigationContextType<NavigableItem> = {
    containerRef,
    service,
    NavigableItemPopoverComponent: NavigableItemPopoverComponent as React.ComponentType<
      NavigableAnnotationPopoverProps<NavigableItem>
    > | null,
    useNavigableItemPopover,
  };

  return (
    <SchemableFormNavigationContext.Provider value={contextValue}>{children}</SchemableFormNavigationContext.Provider>
  );
};
